import { render, staticRenderFns } from "./AppointmentSummary.vue?vue&type=template&id=3cb550a8&scoped=true"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSummary.vue?vue&type=style&index=0&id=3cb550a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb550a8",
  null
  
)

export default component.exports